exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/alert-dialog/alert-dialog.component.css
// module id = ../../../../../src/app/dialog/alert-dialog/alert-dialog.component.css
// module chunks = 4